import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Product, ProductAccessory, ProductInCategoies } from '../../models/products/product.model';
import { ProductService } from '../../services/product/product.service';
import { CategoryService } from '../../services/category/category.service';
import { Category } from '../../models/category/category.model';
import { DisplayCategory } from '../../models/category/DisplayCategory.model';
import { Fields } from '../../models/Fields/field-model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HttpClient, HttpRequest, HttpEventType, HttpEvent } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Customer } from '../../models/customer/customer-model'
import { CustomerService } from '../../services/customer/customer.service';
import { BrandService } from '../../services/brand/brand.service';
import { Brand } from '../../models/brand/brand-model';
import { Subscription } from 'rxjs'
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ProductVariants } from '../../models/products/product.model';
import { Variants } from '../../models/products/product.model';
import { Attributes } from '../../models/products/product.model';
import { ProductsListImages } from '../../models/products/product.model';
import { Warranty } from '../../models/products/product.model';
import { ReturnPolicy } from '../../models/products/product.model';
import { EnumDropDown } from '../../models/shared/enum-dropdown';
import { variable } from '@angular/compiler/src/output/output_ast';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-edit-product',
    templateUrl: './edit-product.component.html',
    styleUrls: ['./edit-product.component.css']
})
/** Edit-Product component*/
export class EditProductComponent {

  product = new Product();
  public products: Product[] = [];
  public productImages: any[] = [];
  public productAccessories: Product[] = [];
  public productInCategoies: Category[] = [];
  public productStatus: EnumDropDown[];
  public selectedProductAccessories: Product[] = [];
  public selectedProductInCategoies: ProductInCategoies[] = [];
  public categryFields: Fields[] = [];
  public productsDropdownSettings = {
    singleSelection: false,
    idField: 'productID',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  public categoriesDropdownSettings = {
    singleSelection: false,
    idField: 'categoryID',
    textField: 'categoryName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  public modalRef: BsModalRef;
  config = {
    animated: true
  };
  public warrantyList: Warranty[] = [];
  public returnPolicyLIst: ReturnPolicy[] = [];
  public vendorsList: Customer[];
  public brandList: Brand[];
  public fieldname: string;
  public parent = new Category();
  public category = new Category();
  public sub = new Category();

  public SelectedCategory: string;
  public specification: any;
  public shortDetail: any;
  public detail: any;
  public inputElement: any;
  public commissionType: boolean;
  public commissionAmount: number;

  public filename: string;
  public excelFile: any;
  //files: any;
  public urls: string[] = [];
  public productID: number;
  public progress: number;
  public message: string;
  public parentid: number;
  public categoryid: number;
  public showSuggestions: boolean;
  public accept = '*';
  public files: File[] = [];
  //progress: number
  public hasBaseDropZoneOver: boolean = false;
  public httpEmitter: Subscription;
  public httpEvent: HttpEvent<Event>;
  public lastFileAt: Date;
  public maxSize: number;
  public validComboDrag: boolean;
  public dragFiles: any;
  public masterProductID: string;
  salePriceMessage: boolean;
  public showCategorySuggestion: boolean = false;
  public showchoseCategory: boolean = false;
  public displayCategory: DisplayCategory[] = [];
  public forecasts: any;
  
  public addProduct = new Product();
  public showProduct: boolean = false;
  public ProductLiveSearch: Product[] = [];
  public showSuggestionsLive: boolean = false;
  sendableFormData: FormData//populated via ngfFormData directive
  configuration = {
    uiColor: '#ffffff',
    toolbarGroups: [{ name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
    { name: 'links' }, { name: 'insert' },
    { name: 'document', groups: ['mode', 'document', 'doctools'] },
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
    { name: 'styles' },
    { name: 'colors' }],
    resize_enabled: false,
    removePlugins: 'save',
    extraPlugins: 'smiley,justify,indentblock,colordialog',
    colorButton_foreStyle: {
      element: 'font',
      attributes: { 'color': '#(color)' }
    },
    height: 188,
    removeDialogTabs: '',
    removeButtons: '',
    format_tags: 'p;h1;h2;h3;pre;div'
  }
  /** edit-simple-product ctor */
  constructor(private _avRoute: ActivatedRoute, private readonly brandsService: BrandService, private modalService: BsModalService, private readonly customerService: CustomerService, public toastr: ToastsManager, vcr: ViewContainerRef, private http: HttpClient, private readonly categoryService: CategoryService, private readonly productService: ProductService,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.checkPermission();
    this.salePriceMessage = true;
    this.product.isActive = true;
    this.product.inStock = true;
    this.filename = "nofile"
    this.product.isFeature = true;
    this.product.categoryID = null;
    this.getcustomers();
    this.getbrands();
    this.SelectedCategory = "";
    this.showSuggestions = false;
    this.commissionType = true;
    this.product.reviewsEnable = true;
    this.product.isOnCash = true;
    this.product.salePrice = 0;
    this.product.commissionPrices = 0;
    this.product.regularPrice = 0;
    this.product.files = [];
    this.product.accessories = [];
    this.product.categories = [];
    this.validComboDrag = true;
    this.GetProductStatus();
    this.selectedProductAccessories = [];
    this.selectedProductInCategoies = [];
    this.product.vendorID = null;
    this.product.brandID = null;
    this.toastr.setRootViewContainerRef(vcr);
    this.masterProductID = "";

    if (this._avRoute.snapshot.params["id"]) {
      this.getProductById(this._avRoute.snapshot.params["master"],this._avRoute.snapshot.params["id"]);
    }
    if (this._avRoute.snapshot.params["master"]) {
      this.masterProductID = this._avRoute.snapshot.params["master"];
    }
  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("product").subscribe(
      data => {
        if (data != null) {
          var create = data.filter(function (element) {
            return (element.action == "editvariable");
          });

          if (create.length > 0) {

          }
          else {
            this.router.navigate(["/product-list"]);
          }
        }
        else {
          this.router.navigate(["/product-list"]);
        }
      }
    )
  }
  removeImage(id: string, index: number) {
    this.productService.DeleteProductImages(id);
    this.productImages.splice(index, 1);
  }
  getProductById(master: string, variant: string) {
    this.productService.GetMasterVaribaleProduct(master, variant).subscribe(data => {
      this.product = data;
      //if (this.product.salePrice == 0) {
      //  this.commissionAmount = this.product.regularPrice - this.product.commissionPrices;
      //}
      //else {
      //  this.commissionAmount = this.product.salePrice - this.product.commissionPrices;
      //}
     // this.commissionAmount = this.product.salePrice - this.product.commissionPrices;
      //this.product.url = this.product.url.substring(0, this.product.url.lastIndexOf("-") + 1);
      //this.product.url = this.product.url.substring(0, this.product.url.length - 1);
      
      if (this.product.commissionType == 1) {
        this.commissionType = true;
      }
      else {
        this.commissionType = false;
      }
      if (this.product.salePrice == 0 && this.commissionType == false) {
        this.commissionAmount = this.product.regularPrice - this.product.commissionPrices;
        this.commissionAmount = (this.commissionAmount / this.product.regularPrice) * 100;
      }
      else if (this.product.salePrice > 0 && this.commissionType == false) {
        this.commissionAmount = this.product.salePrice - this.product.commissionPrices;
        this.commissionAmount = (this.commissionAmount / this.product.salePrice) * 100;
      }
      else if (this.product.salePrice == 0 && this.commissionType == true) {
        this.commissionAmount = this.product.regularPrice - this.product.commissionPrices;
      }
      else if (this.product.salePrice > 0 && this.commissionType == true) {
        this.commissionAmount = this.product.salePrice - this.product.commissionPrices;
      }
      this.detail = this.product.detail;
      this.specification = this.product.specification;
      this.shortDetail = this.product.shortDetail;
      this.categryFields = this.product.fields;
      this.BindCategory(this.product.parentCategoryID, this.product.categoryID, this.product.subCategoryID);
      
      if (this.product.categoriesWithName != null) {
        this.selectedProductInCategoies = this.product.categoriesWithName;
      }
      if (this.selectedProductInCategoies.length > 0) {
        this.showchoseCategory = true;
      }
      if (this.product.productInAccessories != null) {
        this.selectedProductAccessories = this.product.productInAccessories;
      }
      if (this.selectedProductAccessories.length > 0) {
        this.showProduct = true;
      }
      this.productImages = this.product.productImages;
    })

    //this.getAccessoriesProducts();
   // this.getproductInCategoies();
    this.GetWarranties();
    this.GetReturnPolicy();
    this.getcustomers();
    this.getbrands();
  }
  GetProductStatus() {
    this.productService.GetProductStatus().subscribe(
      data => {
        this.productStatus = data;
      }
    )
  }
  GetCommissionType(type: string) {

    if (type == "true") {
      this.commissionType = true;
    }
    else {
      this.commissionType = false;
    }
    var value = "0";
    try {
      value = this.commissionAmount.toString();
    } catch (e) {
    }
    this.calculateCommission(value);
  }
  getcustomers() {
    this.customerService.getActiveVendors().subscribe(
      data => {
        this.vendorsList = data;
      }
    )
  }
  GetWarranties() {

    this.productService.getActiveWarranties().subscribe(
      data => {
        this.warrantyList = data;
     //   this.product.warentyType = this.warrantyList[0].warrantyID;
      }
    )
  }
  getAccessoriesProducts() {
    this.productService.GetProducts().subscribe(
      data => {
        this.productAccessories = data;


        //for (var i = 0; i < this.product.accessories.length; i++) {
        //  try {
        //    var results = this.productAccessories.filter(p => p.productID == this.product.accessories[i].accessoryID)[0];
        //    this.selectedProductAccessories.push(results);
        //  } catch (e) {

        //  }
        //}


      }
    )
  }
  getproductInCategoies() {
    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.productInCategoies = data;
        //for (var i = 0; i < this.product.categories.length; i++) {
        //  try {
        //    var categoryResult = this.productInCategoies.filter(p => p.categoryID == this.product.categories[i].categoryID)[0];
        //    this.selectedProductInCategoies.push(categoryResult);
        //  } catch (e) {

        //  }
        //}
      }
    )
  }
  getbrands() {

    this.brandsService.getBrand().subscribe(
      data => {
        this.brandList = data;
      }
    )
  }
  GetReturnPolicy() {

    this.productService.GetActiveReturnPolicy().subscribe(
      data => {
        this.returnPolicyLIst = data;
    //    this.product.returnPolicy = this.returnPolicyLIst[0].returnPolicyID;
      }
    )
  }
  BindCategory(PID: number, CID: number, SID: number) {
    var categoryList: Category[] = [];
    var ids: number[] = [];
    ids.push(PID);
    ids.push(CID);
    ids.push(SID);
    this.categoryService.GetProductCategory(ids.join()).subscribe(data => {
      categoryList = data;
      for (var i = 0; i < categoryList.length; i++) {
        if (categoryList[i].categoryID == PID) {
          this.parent = categoryList[i];
        }
        if (categoryList[i].categoryID == CID) {
          this.category = categoryList[i];
        }
        if (categoryList[i].categoryID == SID) {
          this.sub = categoryList[i];
        }
      }
      this.SelectedCategory = this.parent.categoryName + " >> " + this.category.categoryName + " >> " + this.sub.categoryName;
    });
  }

  onSubmit() {
    if (this.product.vendorID == null) {
      this.product.vendorID = 0;
    }
    if (this.product.brandID == null) {
      this.product.brandID = 0;
    }
    if (this.product.regularPrice === null) {
      this.product.regularPrice = 0;
    }
    if (this.product.salePrice === null) {
      this.product.salePrice = 0;
    }
    //if (this.product.salePrice === 0) {
    //  this.product.salePrice = this.product.regularPrice;
    //}
    if (this.commissionAmount === null) {
      this.commissionAmount = 0;
    }
    if (Number(this.product.salePrice) > Number(this.product.regularPrice)) {
      this.salePriceMessage = false;
      return;
    }

    this.categryFields.forEach((element) => {
      this.fieldname = "input-" + element.fieldName;
      this.inputElement = document.getElementById(this.fieldname) as HTMLElement;
      element.value = this.inputElement.value;
    });
    this.selectedProductAccessories.forEach((element) => {

      var acc = new ProductAccessory();
      /// public categories: ProductInCategoies[];
      acc.accessoryID = element.productID;
      this.product.accessories.push(acc);
    });
  
    this.product.categories = [];
    if (this.selectedProductInCategoies.length == 0) {
      var cat = new ProductInCategoies();
      cat.categoryID = 0;
      cat.productID = this.product.productID;
      
      this.product.categories.push(cat);
    }
    this.selectedProductInCategoies.forEach((element) => {

      var cat = new ProductInCategoies();
      cat.categoryID = element.categoryID;
      this.product.categories.push(cat);
    });
    this.product.regularPrice = this.product.regularPrice > 0 ? this.product.regularPrice : 0;
    this.product.salePrice = this.product.salePrice > 0 ? this.product.salePrice : 0;
    this.product.commissionPrices = this.product.commissionPrices > 0 ? this.product.commissionPrices : 0;
    this.product.detail = this.detail;
    this.product.shortDetail = this.shortDetail;
    this.product.specification = this.specification;
    this.product.fields = this.categryFields;
    this.product.createdBy = 1;//userid here
    var commissionamount = "0";
    try {
      commissionamount = this.commissionAmount.toString()
    } catch (e) {

    }
    this.calculateCommission(commissionamount);
    if (this.product.salePrice != 0 && this.product.salePrice != this.product.regularPrice) this.product.appliedDiscoutType = 4;
    if (Number(this.product.salePrice) > Number(this.product.regularPrice))
    {
      this.product.salePrice = this.product.regularPrice;
    }
    this.product.commissionType = this.commissionType ? 1 : 0;


    this.product.files = [];
    if (this.files.length>0) {
      for (var i = 0; i < this.files.length; i++) {
        var imageid = "img-" + i;
        var elenment = document.getElementById(imageid).style.backgroundImage;
        var splitted = elenment.split(",");
        var image = splitted[1].replace('"', "").replace(')', "");
        var imgformate = splitted[0].split('/')[1].split(';')[0];
        this.product.files.push(imgformate+"," + image);
        if (i + 1 == this.files.length) {
          this.products.push(this.product);
          this.productService.UpdateVariableSimpleProduct(this.products).subscribe(data => {
            this.toastr.success('Product has been Updated Successfully ', 'Success');
            this.router.navigate(["/edit-variable-product" , this.masterProductID]);
          });
        }
      }
    }
    else {
      this.products.push(this.product);
      this.productService.UpdateVariableSimpleProduct(this.products).subscribe(data => {
        this.toastr.success('Product has been Updated Successfully ', 'Success');
        this.router.navigate(["/edit-variable-product" , this.masterProductID]);
      });

    }
  }

  calculateCommission(searchValue: string) {
    var price: number;
    try {
      var number = Number(searchValue);

      price = this.product.salePrice > 0 ? this.product.salePrice : this.product.regularPrice;
      if (this.commissionType) {
        if (number > price) number = price;
        price = price - number;
      }
      else {
        if (number > 100) number = 100;
        price = price - ((number / 100) * price);
      }
      this.product.commissionPrices = price;
    } catch (e) {

    }
  }
  keyPress(event: any) {
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
  //SalePriceCheck(searchValue: string) {
  //  var price: number;
  //  try {
  //    var number = Number(searchValue);
  //    if (number > this.product.regularPrice) this.product.salePrice = this.product.regularPrice;
  //  } catch (e) {
  //    number = 0;
  //  }

  //}
  SalePriceCheck() {
    if (Number(this.product.salePrice) > Number(this.product.regularPrice) && this.product.regularPrice != 0 && typeof this.product.regularPrice != "undefined") {
      this.salePriceMessage = false;
    }
    else {
      this.salePriceMessage = true;
    }
  }
  onTextChange(Value: string) {

    var i = 0, strLength = Value.length;
    for (i; i < strLength; i++) {
      Value = Value.replace(" ", "-");
    }
    this.product.url = Value.toLowerCase();
  }
  hideCommision() {
    if (this.product.salePrice === 0) {
      this.product.salePrice = null;
    }
    if (this.product.salePrice == null || this.product.salePrice.toString() == "") {
      this.product.commissionPrices = 0;
      this.commissionAmount = null;
    }
    if (this.product.regularPrice === 0) {
      this.product.regularPrice = null;
    }
  }
  onSearch(searchText: string, id: number) {
    
    var length = 0;
    try {
      length = searchText.length;
    } catch (e) {
      if (id == 1) {
        this.showSuggestions = false;
      }
      else {
        this.showCategorySuggestion = false;
      }
      return;
    }
    if (length > 0) {
      this.categoryService.CategoriesSuggestions(searchText).subscribe(
        data => {
          this.forecasts = data;
          this.displayCategory = this.forecasts.filter(i => i.parentCategoryID === 0);
          this.displayCategory.forEach(element => {
            element.subCategory = this.forecasts.filter(i => i.parentCategoryID === element.categoryID);
            element.subCategory.forEach(child => {
              child.subCategory = this.forecasts.filter(i => i.parentCategoryID === child.categoryID);
            });
          });
          if (this.displayCategory.length > 0) {
            if (id == 1) {
              this.showSuggestions = true;
            }
            else {
              this.showCategorySuggestion = true;
            }
          }

        });
    }
    else {
      this.displayCategory = [];
      this.showSuggestions = false;
    }
  }
  addRelatedCategories(id: number, name: string) {
    
    var cat = new ProductInCategoies();
    cat.categoryID = id;
    cat.categoryName = name;
    if (!this.selectedProductInCategoies.some((item) => item.categoryID == cat.categoryID)) {
      this.selectedProductInCategoies.push(cat);
      this.showchoseCategory = true;
      this.showCategorySuggestion = false;
    }
    else {
      this.toastr.error('This item is already Exist', 'Fail!');
    }
    this.showCategorySuggestion = false;
    //this.selectedProductInCategoies.push(cat);
    //var catwithname = new ProductInCategoies();
    //catwithname.categoryID = id;
    //catwithname.categoryName = name;
    //this.product.categoriesWithName.push(catwithname);
  }
  removeCategory(index) {
    this.selectedProductInCategoies.splice(index, 1);
    if (this.selectedProductInCategoies.length == 0) {
      this.showchoseCategory = false;
    }
  }
  LiveSearchProduct(searchText: string) {
    var length = 0;
    try {
      length = searchText.length;
    } catch (e) {
      this.showSuggestionsLive = false;
      return;
    }
    if (length > 0) {
      this.productService.ProductSuggestions(searchText).subscribe(
        data => {
          this.ProductLiveSearch = data;
          if (this.ProductLiveSearch.length > 0) {
            this.showSuggestionsLive = true;
          }
        });
    }
    else {
      this.ProductLiveSearch = [];
      this.showSuggestionsLive = false;
    }
  }
  SelectProduct(product: Product) {
    this.addProduct = product;
    if (!this.selectedProductAccessories.some((item) => item.productID == this.addProduct.productID)) {
      this.selectedProductAccessories.push(this.addProduct);

      this.showProduct = true;
      this.showSuggestionsLive = false;
    }
    else {
      this.toastr.error('This item is already Exist', 'Fail!');
    }
    this.showSuggestionsLive = false;
  }
  removeProduct(index) {
    this.selectedProductAccessories.splice(index, 1);
    if (this.selectedProductAccessories.length == 0) {
      this.showProduct = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/product-components/edit-product/edit-product.component.ts